export const siteNameFilterFunction = (rows, rowId, filterValue) => {
  if (!filterValue || !filterValue.length) return rows;
  return rows.filter((row) =>
    row.original.siteName.toLowerCase().includes(filterValue.toLowerCase())
  );
};

export const ALL_VALUE = { name: 'All', id: 'all' };
